<template>
  <backbar-page-layout
    v-if="canPerform('authcore.users.get')"
    back-title="title.users"
    title="title.metadata"
    :user-id="id"
    :loading="isLoadingStatus"
  >
    <template #alert>
      <b-row>
        <b-col>
          <b-alert
            :show="updateDone"
            variant="success"
          >
            {{ $t('status.success.update_metadata') }}
          </b-alert>
          <b-alert
            :show="updateError !== undefined"
            variant="danger"
          >
            {{ $t(updateError) }}
          </b-alert>
        </b-col>
      </b-row>
    </template>
    <b-container class="mt-4">
      <h5 class="font-weight-bold">{{ $t('general.user_metadata') }}</h5>
      <hr class="mt-1 mb-4" />
      <b-row class="mb-5">
        <b-col class="shallow-transparency">
          <!-- TODO: Last updated user metadata -->
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col>
          {{ $t('description.user_metadata') }}
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col>
          <codemirror
            v-model="formattedUserMetadata"
            :options="cmOptions"
          ></codemirror>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="3" class="ml-auto text-right">
          <b-button block variant="outline-primary" @click="updateUserMetadata">{{ $t('button.save') }}</b-button>
        </b-col>
      </b-row>

      <h5 class="font-weight-bold">{{ $t('general.app_metadata') }}</h5>
      <hr class="mt-1 mb-4" />
      <b-row class="mb-5">
        <b-col class="shallow-transparency">
          <!-- TODO: Last updated app metadata -->
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col>
          {{ $t('description.app_metadata') }}
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col>
          <codemirror
            v-model="formattedAppMetadata"
            :options="cmOptions"
          ></codemirror>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="3" class="ml-auto text-right">
          <b-button block variant="outline-primary" @click="updateAppMetadata">{{ $t('button.save') }}</b-button>
        </b-col>
      </b-row>
    </b-container>
  </backbar-page-layout>
</template>

<style>
.CodeMirror {
    height: 10vh;
}
</style>

<script>
// Set the json lint for codemirror
import jsonlint from 'jsonlint-mod'

import { mapState } from 'vuex'
import { codemirror } from 'vue-codemirror'
import { js_beautify as jsBeautify } from 'js-beautify'

import 'codemirror/mode/javascript/javascript'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/base16-dark.css'
import 'codemirror/addon/lint/lint.css'
import 'codemirror/addon/lint/lint'
import 'codemirror/addon/lint/json-lint'

import BackbarPageLayout from '@/components/BackbarPageLayout.vue'
import store from '@/store'
window.jsonlint = jsonlint

export default {
  name: 'UserDetailsMetadata',
  components: {
    codemirror,
    BackbarPageLayout
  },

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      cmOptions: {
        lint: true,
        indentUnit: 4,
        tabSize: 4,
        mode: {
          name: 'javascript',
          json: true
        },
        gutters: ['CodeMirror-lint-markers'],
        lineNumbers: true,
        line: true,
        theme: 'base16-dark'
      },
      updatedUserMetadata: '',
      updatedAppMetadata: ''
    }
  },

  computed: {
    ...mapState('client', [
      'authenticated'
    ]),
    ...mapState('management/userDetails/metadata', [
      'loading',
      'error',
      'updateDone',
      'updateError',

      'userMetadata',
      'appMetadata'
    ]),
    isLoadingStatus () {
      return !this.authenticated || this.loading
    },
    formattedUserMetadata: {
      get () {
        return jsBeautify(this.userMetadata)
      },
      set (newValue) {
        this.updatedUserMetadata = newValue
      }
    },
    formattedAppMetadata: {
      get () {
        return jsBeautify(this.appMetadata)
      },
      set (newValue) {
        this.updatedAppMetadata = newValue
      }
    }
  },

  mounted () {
    store.dispatch('management/userDetails/metadata/list', this.id)
  },

  destroyed () {
    store.commit('management/userDetails/metadata/CLEAR_ACTION_STATES')
  },

  methods: {
    async updateUserMetadata () {
      await store.dispatch('management/userDetails/metadata/updateUserMetadata', {
        id: this.id,
        userMetadata: this.updatedUserMetadata
      })
    },
    async updateAppMetadata () {
      await store.dispatch('management/userDetails/metadata/updateAppMetadata', {
        id: this.id,
        appMetadata: this.updatedAppMetadata
      })
    }
  }
}
</script>
